import { required } from 'vuelidate/lib/validators';

export default {
    validations: {
        selectedTemplate: {
            subject: { required },
            senderEmail: { required },
            receiverEmail: { required }
        }
    }
};
